<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-ml-4 p-mr-4">
        <div class="p-formgrid p-grid p-col-12 p-mt-3">
          <div class="p-col-12 p-lg-6">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-10">
                <label class="p-mr-2">{{ $t("response_agency") }}</label>
                <Button
                  @click="showOrganize = true"
                  icon="pi pi-plus"
                  class="p-button-success"
                />
              </div>
            </div>
            <span class="p-invalid" v-if="error_table == true">{{
              $t("table_validate")
            }}</span>
            <div class="p-field p-col p-mt-2" style="margin-left: -10px">
              <DataTable
                :value="organize_table"
                :scrollable="true"
      scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                :rowHover="true"
                :filters="filters"
                :selection.sync="selectedOrganizeData"
                sortField="organize_name"
                :sortOrder="1"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="organize_name"
                  :header="$t('id_operating_name')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    <div hidden>{{ dataTable.data.organize_id }}</div>
                    {{ dataTable.data.organize_name }}
                  </template>
                </Column>
                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                  <template #body="dataTable">
                    <div class="p-formgrid p-grid">
                      <div class="p-field p-col-6">
                        <Button
                          @click="
                            // displayConfirmation = true;
                            organizeDelete = dataTable.data;
                            alertDisplay(organizeDelete)
                          "
                          icon="pi pi-trash"
                          :label="$t('deleteBtn')"
                          class="p-button-rounded p-button-danger"
                        />
                      </div>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
          <div class="p-col-12 p-lg-6 p-mt-3">
            <div class="p-formgrid p-grid p-col">
              <div class="p-field p-col-12 p-lg-6 p-mt-2">
                <label>{{ $t("startMonthYear") }}</label>
                <div class="p-formgrid p-grid">
                  <div class="p-field p-col-12 p-lg-6 p-mt-2">
                    <Dropdown
                      v-model="selectedStartMonth"
                      :options="month"
                      optionLabel="name"
                      id="ds_selectedStartMonth"
                    />
                  </div>
                  <div class="p-field p-col-12 p-lg-4 p-mt-2" >
                    <Dropdown
                      v-model="selectedStartYear"
                      :options="year"
                      optionLabel="name"
                      id="ds_selectedStartYear"
                    />
                  </div>
                </div>
              </div>
              <div class="p-field p-col-12 p-lg-6 p-mt-2">
                <label>{{ $t("endMonthYear") }}</label>
                <div class="p-formgrid p-grid">
                  <div class="p-field p-col-12 p-lg-6 p-mt-2">
                    <Dropdown
                      v-model="selectedEndMonth"
                      :options="month"
                      optionLabel="name"
                      id="ds_selectedEndMonth"
                    />
                  </div>
                  <div class="p-field p-col-12 p-lg-4 p-mt-2" style="margin-top: -7px">
                    <Dropdown
                      v-model="selectedEndYear"
                      :options="year"
                      optionLabel="name"
                      id="ds_selectedEndYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="p-formgrid p-grid p-mt- p-mb-4 p-col">
              <div class="p-field p-col-12 p-lg-4 p-mr-6 p-mt-2">
                <label>{{ $t("disaster_type") }}</label>
                <MultiSelect
                  v-model="selectedDisaster"
                  :options="disasterOptions"
                  optionLabel="system_name"
                  :placeholder="$t('placeholderSelectBox')"
                  :filter="true"
                  class="multiselect-custom"
                  :clearFilterMultiSelect="multiSelectClearFilerValue"
                >
                  <template #value="slotProps">
                    <div
                      class="item item-value"
                      v-for="option of slotProps.value"
                      :key="option.system_id"
                    >
                      <div>{{ option.system_name }}</div>
                    </div>
                    <template
                      v-if="!slotProps.value || slotProps.value.length === 0"
                    >
                      {{ $t("placeholderSelectBox") }}
                    </template>
                  </template>
                  <template #option="slotProps">
                    <div class="item">
                      <div class="EV_disasterOptions">{{ slotProps.option.system_name }}</div>
                    </div>
                  </template>
                </MultiSelect>
                <span class="p-invalid" v-if="error_disaster == true">{{
                  $t("table_validate")
                }}</span>
              </div>

              <div class="p-field p-col-12 p-lg-3 p-mt-2">
                <label>{{ $t("selectedChart") }}</label>
                <div class="p-formgrid p-grid">
                  <div class="p-field p-col-12">
                    <Dropdown
                      v-model="selectedChart"
                      :options="chartOptions"
                      optionLabel="name"
                      id="ds_selectedChart"
                    />
                  </div>
                </div>
              </div>

              <div class="p-field p-col-12 p-lg-4">
                <div class="p-formgrid p-grid p-mt-5 p-jc-end">
                  <Button
                    @click="clearSearchField()"
                    :label="$t('clearBtn')"
                    class="p-button-clear p-mr-3 p-ml-1"
                  />
                  <Button
                    @click="search()"
                    :label="$t('searchBtn')"
                    class="p-button-info"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fieldset>

    <Dialog
      :modal="true"
      :header="$t('OrganizeModalHeader')"
      :visible.sync="showOrganize"
      :style="{ width: '80%' }"
      :contentStyle="{ 'overflow-y': 'scroll' }"
    >
      <organize-table
        @selectOrganization="selectedOrganize_passValue"
        :parentmessage="parentmessage_organize"
      ></organize-table>
    </Dialog>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-lg-6">
        <div class="card p-fluid p-mt-2">
          <DataTable
            :value="table"
            :scrollable="true"
            scrollHeight="500px"
            :paginator="true"
            :rows="10"
            :rowsPerPageOptions="[10, 20, 50]"
            sortField="system_name"
            :sortOrder="1"
            :loading="loading"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
          >
          <template #empty>{{ $t("TableEmpty") }}</template>
            <Column
              field="system_name"
              :header="$t('disaster_type')"
              headerStyle="width: 200px"
            >
              <template #body="dataTable">
                {{ dataTable.data.system_name }}
              </template>
            </Column>
            <div v-for="headers in headerOrganize" :key="headers.id">
              <Column :header="headers.name" headerStyle="width: 100px">
                <template #body="dataTable">
                  <div
                    v-for="result in result_table"
                    :key="JSON.stringify(result)"
                  >
                    <div v-if="dataTable.data.system_id == result.system_id">
                      <div v-if="headers.id == result.organize">
                        {{ result.amount_type }}
                      </div>
                    </div>
                  </div>
                </template>
              </Column>
            </div>
          </DataTable>
        </div>
      </div>

      <div class="p-col-12 p-lg-6">
        <div class="card p-mt-2">
          <div class="chartAreaWrapper">
          <h5 class="centerText">
            {{ $t("TopicGraphReportOrganize_Agency") }}
          </h5>
          <span class="centerText">{{ subtopic }}</span>
          <div v-if="selectedChart.value == 'bar' || selectedChart.value == 'line' ">
                 <Chart :type="selectedChart.value" :data="barData" class="walking-speed-chart"/>
                </div>
                <div v-else>
                  <Chart :type="selectedChart.value" :data="pieData" class="walking-speed-chart"/>
                </div>
          <!-- <Chart :type="selectedChart.value" :data="barData" /> -->
        </div>
      </div>
      </div>
    </div>

    <Dialog
      :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import organizeTable from "../OrganizeMultiSelectTable";

export default {
  name: "statistic-organize-response",
  components: {
    organizeTable,
  },
  data() {
    return {
      multiSelectClearFilerValue:0,
      month: this.$month,
      year: [],

      selectedStartMonth: null,
      selectedStartYear: null,
      selectedEndMonth: null,
      selectedEndYear: null,

      filters: {},
      table: [],
      barData: {},
      pieData: {},
      headerOrganize: [],

      disasterOptions: [],
      selectedDisaster: null,
      subtopic: "",

      chartOptions: [],
      selectedChart: { id: 1, name: "แบบ Bar", value: "bar" },

      displayConfirmation: false,
      showOrganize: false,
      organize_table: [],
      organizeDelete: null,
      error_table: false,
      error_disaster: false,

      selectedOrganizeData: null,

      result_table: [],
      label: [],

      parentmessage_organize: null,

      loading:false,
    };
  },

  watch: {
    showOrganize(val) {
      if (val == true) {
        if (this.organize_table.length > 0) {
          this.parentmessage_organize = this.organize_table;
        } else {
          this.parentmessage_organize = [];
        }
      }
    },
    organize_table(val) {
      if (val.length > 0) {
        this.error_table = false;
      }
    },

    disasterOptions(val) {
      if (val != null) {
        this.selectedDisaster = val;
      }
    },

    selectedDisaster(val) {
      if (val != null) {
        this.error_disaster = false;
        if (val.length == 0) {
          this.selectedDisaster = null;
        }
      }
    },

    result_table(val) {
      if (val.length != 0) {
        var letters = "0123456789ABCDEF";
        var color = "#";
        var dataset = [];
        var result = [];
        var resultPie = [];

        // console.log('val = ',JSON.stringify(val));
        for (let i = 0; i < val.length; i++) {
          result.push(val[i]);
        }

        // console.log('result = ',result);


        for (let i = 0; i < val.length; i++) {
              resultPie.push({organize_name: `${val[i].organize_name}`, system_name: `${val[i].system_name}`,amount_type : `${val[i].amount_type}` });
        }
                // console.log('resultPie = ',resultPie);


        var all_amount = [];
        for (let t = 0; t < this.headerOrganize.length; t++) {
          for (let i = 0; i < this.selectedDisaster.length; i++) {
            for (let j = 0; j < result.length; j++) {
              if (this.headerOrganize[t].id == result[j].organize) {
                if (this.selectedDisaster[i].system_id == result[j].system_id) {
                  all_amount.push(`${result[j].amount_type}`);
                } else {
                  all_amount.push("0");
                }
              } else {
                all_amount.push("0");
              }
            }
          }
        }

        var number = [];
        var index;
        var all = [];
        for (let j = 0; j < this.headerOrganize.length; j++) {
          for (let i = 1; i <= this.selectedDisaster.length; i++) {
            index = i * result.length;
            var temp = 0;
            for (let k = index - result.length; k < index; k++) {
              temp += Number(all_amount[k]);
            }
            number.push(temp);
          }
          all_amount = all_amount.slice(index);
          all.push({ id: number });
          number = [];
        }
//datasets of barData
        for (let j = 0; j < this.headerOrganize.length; j++) {
          for (let k = 0; k < 6; k++) {
            color += letters[Math.floor(Math.random() * 16)];
          }
          dataset.push({
            label: `${this.headerOrganize[j].name}`,
            backgroundColor: `${color}`,
            borderColor: `${color}`,
            data: all[j].id,
          });
          color = "#";
        }

        this.barData = {
          labels: this.label,
          datasets: dataset,
        };


        //datasets of pieData
      var labelPie = [];
      var colorPie = [];
      var dataPie = [];
        for (let j = 0; j < val.length; j++) {

          labelPie.push(`${resultPie[j].organize_name} : ${resultPie[j].system_name}`);
            for (let k = 0; k < 6; k++) {
              color += letters[Math.floor(Math.random() * 16)];
            }
            colorPie.push(`${color}`);
            dataPie.push(resultPie[j].amount_type);
            color = "#";
        }

        // console.log('datasetPieData = ',datasetPieData);
        // console.log('labelPie = ',labelPie);
        // console.log('colorPie = ',colorPie);
        // console.log('dataPie = ',dataPie);

        this.pieData = {
          labels: labelPie,
          datasets: [
                    {
                        data: dataPie,
                        backgroundColor: colorPie,
                        hoverBackgroundColor: colorPie
                    }
                ],
        };

      }
    },
  },
  async created() {
    this.table = [];
    this.chartOptions.push({ id: 1, name: "แบบ Bar", value: "bar" });
    this.chartOptions.push({ id: 2, name: "แบบ Pie", value: "pie" });
    this.chartOptions.push({ id: 3, name: "แบบ Line", value: "line" });
    this.chartOptions.push({ id: 4, name: "แบบ Doughnut", value: "doughnut" });

    await this.axios
      .post(`${this.$url_service}/initial/option`, {
        body: { group: "dg-02" },
      })
      .then((response) => {
        this.disasterOptions = response.data.data;
      });
    this.selectedStartMonth = { id: "01", name: "มกราคม", shrt: "ม.ค." };
    var current_month, found;
    if (`${new Date().getMonth() + 1}`.length == 1) {
      current_month = `0${new Date().getMonth() + 1}`;
      found = this.month.find((x) => x.id === current_month);
    } else {
      current_month = `${new Date().getMonth() + 1}`;
      found = this.month.find((x) => x.id === current_month);
    }
    this.selectedEndMonth = {
      id: current_month,
      name: `${found.name}`,
      shrt: `${found.shrt}`,
    };

    var current_year = new Date().getFullYear();
    this.selectedStartYear = {
      id: `${current_year}`,
      name: `${current_year + 543}`,
    };
    this.selectedEndYear = {
      id: `${current_year}`,
      name: `${current_year + 543}`,
    };
    for (let i = 0; i < 12; i++) {
      this.year.push({ id: `${current_year}`, name: `${current_year + 543}` });
      current_year--;
    }
  },
  mounted() {},
  methods: {
    selectedOrganize_passValue(variable) {
      this.showOrganize = false;
      if (variable != null) {
        this.organize_table = [];
        for (let i = 0; i < variable.length; i++) {
          this.organize_table.push(variable[i]);
        }
      }
    },

    confirmDelete() {
      this.organize_table = this.organize_table.filter(
        (val) => val !== this.organizeDelete
      );
      this.displayConfirmation = false;
      this.organizeDelete = null;
    },

    search() {
      this.table = [];
      this.headerOrganize = [];
      this.barData = {};
      this.pieData = {}
      this.label = [];
      this.subtopic = ""
      if (this.organize_table.length == 0 || this.selectedDisaster == null) {
        if (this.organize_table.length == 0) {
          this.error_table = true;
        }
        if (this.selectedDisaster == null) {
          this.error_disaster = true;
        }
      } else {
        if (this.selectedStartYear.id <= this.selectedEndYear.id) {
          // if (
          //   Number(this.selectedStartMonth.id) <=
          //   Number(this.selectedStartMonth.id)
          // ) {
          if (this.selectedStartYear.id == this.selectedEndYear.id) {
            if (this.selectedStartMonth.id <= this.selectedEndMonth.id) {
              this.setHeader();
                if (this.selectedDisaster != null) {
                  for (let i = 0; i < this.selectedDisaster.length; i++) {
                    this.table.push({
                      system_name: `${this.selectedDisaster[i].system_name}`,
                      system_id: `${this.selectedDisaster[i].system_id}`,
                    });
                    this.label.push(`${this.selectedDisaster[i].system_name}`);
                  }
                } else {
                  this.table.push({ system_name: `` });
                }
              }
            }else{
                this.setHeader();
                if (this.selectedDisaster != null) {
                  for (let i = 0; i < this.selectedDisaster.length; i++) {
                    this.table.push({
                      system_name: `${this.selectedDisaster[i].system_name}`,
                      system_id: `${this.selectedDisaster[i].system_id}`,
                    });
                    this.label.push(`${this.selectedDisaster[i].system_name}`);
                  }
                } else {
                  this.table.push({ system_name: `` });
                }
          }
            
          // }
        }
      }
    },

    async setHeader() {
      this.table = [];
      this.label = [];
      this.headerOrganize = [];
      this.subtopic = `${this.selectedStartMonth.name} ${this.selectedStartYear.name} ถึง ${this.selectedEndMonth.name} ${this.selectedEndYear.name}`;
      for (let i = 0; i < this.organize_table.length; i++) {
        this.headerOrganize.push({
          name: `${this.organize_table[i].organize_name}`,
          id: `${this.organize_table[i].organize_id}`,
        });
      }
      this.loading = true;
      await this.axios
        .post(`${this.$url_service}/get/statistic`, {
          body: {
            topic: "get-organization-group",
            start_month: this.selectedStartMonth.id,
            end_month: this.selectedEndMonth.id,
            start_year: this.selectedStartYear.id,
            end_year: this.selectedEndYear.id,
            type: this.selectedDisaster,
            organize: this.organize_table,
          },
        })
        .then((response) => {
          // console.log(response.data.data),
            (this.result_table = response.data.data);
        });
        this.loading = false;
    },

    clearSearchField() {
      this.multiSelectClearFilerValue +=1 ;
      this.table = [];
      this.headerOrganize = [];
      this.error_table = false;
      this.organize_table = [];
      this.selectedDisaster = null;
      this.barData = [];
    },
    alertDisplay(temp) {
      this.$fire({
                    title: "ยืนยันการลบข้อมูล",
                    text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    // console.log(temp)
                    if (result.value) {
                      // console.log(temp)
                      this.confirmDelete(temp)
                    }
                  })
    },
  },
  computed: {},
};
</script>

<style scoped lang="scss">
@media screen and (max-width: 430px) {
  .EV_disasterOptions{
  width: 14.5rem;
  overflow-y:scroll;
  }
  .EV_disasterOptions::-webkit-scrollbar {
    width: 0;
    height: 1px;
    
  }

  .EV_disasterOptions::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1); 
      
      
  }

  .EV_disasterOptions::-webkit-scrollbar-thumb {
      
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2); 
      
  }
}

.p-multiselect {
  min-width: 15rem;
}

.multiselect-custom {
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .item {
    display: flex;
    align-items: center;
  }

  .item-value {
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 3px;
    display: inline-flex;
    margin-right: 0.5rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
}
</style>

<style scoped>
.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>


<style>
  /* ! ส่วนกราฟ */
  .chartAreaWrapper {
         width: 100%;
         overflow-x: scroll;
    }
  
  .walking-speed-chart{
         /* margin-top: 20px; */
         height: 80%;
         width: 880px;
    }
  
  
    @media screen and (max-width: 1540px) {
      .walking-speed-chart{
         height: 80%;
         width: 690px;
    }
  
  }
  
  /* ! จบส่วนกราฟ */
  </style>